import axios from 'axios';
import { useState, useEffect } from "react";

import { getModalStyle } from '@/utils/Modal';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import Input from '@/components/Input';
import Switch from '@/components/Switch';
import Dropdown from '@/components/Dropdown';

import {
    Close as CloseIcon,
    Send as SendIcon
} from '@mui/icons-material';

import Button from '@/components/Button';

import { getErrorMessage } from '@/utils/Errors';

export default function ReportNotificationModal({t, report, open, setOpen, fullScreen, apiUrl, 
    token, language, sendMessage, handleLogin, user, users, item}){

    const [ data, setData ] = useState({
        users: null,        
        direction: true,
        emails: ''
    });

    useEffect(() => {
        if(open){
            setData({
                users: users,
                direction: true,
                emails: ''
            });
        }
    },[open]);

    const handleInput = (e) => {
        
        var name = e.target.name;
        var value = e.target.value;

        var newData = {...data};
        newData[name] = value;
        setData(newData);
    };

    const handleInputSwitch = (e) => {
        
        const name = e.target.name;
        var value = e.target.checked;
        
        var newData = {...data};
        newData[name] = value;
        setData(newData);
    }

    const handleUsers = (dropdownData) => {       
        var newData = {...data};
        newData['users'] = dropdownData;
        setData(newData);
    }

    const { sxDialog/*, sxCloseIcon*/ } = getModalStyle();

    const handleClose = () => {
        setOpen(false);
    }

    // send notification
    const handleSendNotification = () => {

        if(
            (!data.users || data.users?.length === 0) &&
            (!data.emails || data.emails?.length === 0) &&
            !data.direction
        ){
            sendMessage(t(report+'.update.errors.empty'),'error');
        }
        else{

            const apiPath = '/'+report+'/notify';

            const config = {
                headers: { Authorization: `Bearer ${token}` } 
            };

            const send = {
                language: language,
                companyuser: user?.company,
                item: item?.id,
                direction: data.direction
            };

            // get emails
            const emails = [];
            if(data.emails){
                emails.push(...data.emails.split(','));
            }             

            if(data.users && data.users?.length > 0){
                emails.push(...data.users.map(user => user?.email));
            }
            
            send.emails = emails.join(',');

            var errorMessage = t(report+'.update.error');
            
            const url = apiUrl+apiPath;
            
            axios.post(url,send,config)
            .then(function (response) {

                if(response?.data){
                
                    const responseData = response.data;                

                    // if result is ok (1)
                    if(responseData?.result){                        
                        sendMessage(t(report+'.update.success'));
                        handleClose();
                    } 
                    else{
                        if(responseData?.status && responseData.status === 401){
                            handleLogin();                        
                        }
                        else{
                            // check error message
                            if(responseData?.data?.reasons){
                                errorMessage = getErrorMessage(t,report,responseData?.data?.reasons);                                
                            }
                            
                            sendMessage(errorMessage,'error');
                        }                        
                    }
                }
                else{                
                    sendMessage(errorMessage,'error');                    
                }
            })
            .catch(function (error){
                
                if(error?.status && error.status === 401){
                    handleLogin();                        
                }
                else{                        
                    sendMessage(errorMessage,'error');
                }
            });
        }
    }

    return (
        
        <Dialog
            container={fullScreen?.active ? fullScreen?.node?.current : null}
            sx={sxDialog}
            onClose={handleClose}
            open={open}
            fullWidth={true}
            maxWidth='lg'
        >
            <DialogTitle className='modal-title'>
                {t(report+'.update.title')}
            </DialogTitle>
            <DialogContent className='modal-content'>                 
                <div className='mb-4 mt-2'>
                    <Dropdown                    
                        type='multiple'
                        name='users'
                        placeholder={t(report+'.update.fields.users')}
                        value={data.users}
                        options={users}
                        handleDropdown={handleUsers}
                    />
                </div>                 
                <div className='mb-4'>
                    <Input                      
                        name='emails'
                        type="text"
                        value={Object.hasOwn(data,'emails') && data['emails']}                      
                        placeholder={t(report+'.update.fields.emails')}
                        onChange={handleInput}                        
                    />
                </div>
                <div className='mb-4'>
                    <Switch                                                                    
                        name='direction'
                        checked={data.direction}
                        label={t(report+'.update.fields.direction')}
                        onChange={handleInputSwitch}                              
                    />
                </div>
            </DialogContent>
            <div className="modal-buttons">
                <div className='me-1'>
                    <SendIcon className='action-button-modal text-green-800' onClick={handleSendNotification}/>
                </div>
                <div className=''>
                    <CloseIcon className='action-button-modal text-black' onClick={handleClose}/>
                </div>
            </div>
        </Dialog>
  );
}